import React from "react";
import { Path, Svg, SVGProps } from "@react-pdf/renderer";

export const TickIcon = ({ style, ...props }: SVGProps) => (
  <Svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ ...style, width: props.width, height: props.height }} {...props}>
    <Path d="M4.50002 10.2114L1.39502 7.10641L2.81002 5.69141L4.50002 7.38641L9.44002 2.44141L10.855 3.85641L4.50002 10.2114Z" fill="#04C28E" />
  </Svg>
)